
export const formatPhone = (value: string | number | null | undefined): string | number | null | undefined => {
  const cleaned = ('' + value).replace(/\D/g, '').slice(0, 10);
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }

  return value;
};

export const maskPhone = (val: string | number | null | undefined): string => {
  if (!val) return '';
  const inputValue = String(val);
  return (
    '(***) ***-' + inputValue.slice(inputValue.length - 4, inputValue.length)
  );
};

const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;

export const validatePhoneNumber = (_: unknown, value: string): Promise<void> => {
  return phoneRegex.test(value) ? Promise.resolve() : Promise.reject(new Error('Invalid phone number format'));
};
